export default class GanttItem {
  rpId: number;
  parentId: number;

  constructor(response: unknown) {
    const data = response as { RP_ID: number; PARENT_ID: number };
    this.rpId = data.RP_ID;
    this.parentId = data.PARENT_ID;
  }
}
